module.exports = __webpack_public_path__ + "static/media/control_de_carga1.ea6457e4.svg";